import React from 'react';
import { makeStyles } from '@mui/styles';
import { remCalc } from '../../util/style-util';
import maybe from './enhancers/maybe';
import TrialBadge from '../Badges/TrialBadge';
import { useTheme } from '@mui/material';

type Props = {
  isTrialLicense: boolean;
  themeColor: string;
  textColor: string;
  trialDaysLeft: number;
  showTrialModal: () => void;
} & any;

const MaybeTrialBadge: any = maybe(TrialBadge);

function Footer({ isTrialLicense, trialDaysLeft, showTrialModal }: Props) {
  const theme = useTheme();
  const classes = useStyles(theme)();

  return (
    <footer className={classes.footer}>
      <MaybeTrialBadge
        showTrialModal={showTrialModal}
        shouldRender={isTrialLicense}
        daysLeft={trialDaysLeft}
      />
    </footer>
  );
}

const useStyles = theme =>
  makeStyles(() => ({
    footer: () => ({
      width: '100%',
      paddingTop: remCalc(15),
      minHeight: remCalc(50),
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      alignItems: 'center'
    })
  }));

export default Footer;
